export const GET_PROJECT_LIST = 'GET_PROJECT_LIST'
export const API_CALL_INITIATED_PROJECT_LIST = 'API_CALL_INITIATED_PROJECT_LIST'
export const ADD_LIST_PAGE_META_PROJECT_LIST = 'ADD_LIST_PAGE_META_PROJECT_LIST'
export const API_CALL_FAIL_PROJECT_LIST = 'API_CALL_FAIL_PROJECT_LIST'
export const FETCH_SUCCESS_PROJECT_LIST = 'FETCH_SUCCESS_PROJECT_LIST'
export const CLEAR_PROJECT_LIST = 'CLEAR_PROJECT_LIST'
export const NO_PROJECTS_FOUND_PROJECT_LIST = 'NO_PROJECTS_FOUND_PROJECT_LIST'
